var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParesPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "card-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "145%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 4,
    floodColor: "#064E3B",
    floodOpacity: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "neon-glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBg",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sunGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#059669"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 38,50 C 70,30 50,90 82,70",
    fill: "none",
    stroke: "#A7F3D0",
    strokeWidth: 7,
    strokeLinecap: "round",
    opacity: 0.4,
    filter: "url(#neon-glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38,50 C 70,30 50,90 82,70",
    fill: "none",
    stroke: "url(#lineGrad)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38,50 C 70,30 50,90 82,70",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 20) rotate(-6)",
    filter: "url(#card-shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 52,
    rx: 10,
    fill: "url(#cardBg)",
    stroke: "#10B981",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 46,
    rx: 7,
    fill: "none",
    stroke: "#34D399",
    strokeWidth: 1,
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-12 L0,-8 M0,8 L0,12 M-12,0 L-8,0 M8,0 L12,0 M-8,-8 L-5,-5 M5,5 L8,8 M-8,8 L-5,5 M5,-5 L8,-8",
    stroke: "#F59E0B",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "url(#sunGrad)",
    stroke: "#EA580C",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 6,
    height: 5,
    rx: 1,
    fill: "#94A3B8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 1,
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68, 42) rotate(6)",
    filter: "url(#card-shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 52,
    rx: 10,
    fill: "url(#cardBg)",
    stroke: "#059669",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 46,
    rx: 7,
    fill: "none",
    stroke: "#10B981",
    strokeWidth: 1,
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 26,
    height: 15,
    rx: 3,
    fill: "#E6F4EA",
    stroke: "#A7F3D0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 31,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 7.5,
    fontWeight: 900,
    fill: "#047857",
    textAnchor: "middle"
  }, "Hyadi"), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 6,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#94A3B8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 8,
    x2: 29,
    y2: 8,
    stroke: "#FFFFFF",
    strokeWidth: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#neon-glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52,22 L 54,25 L 58,26 L 54,27 L 52,30 L 50,27 L 46,26 L 50,25 Z",
    fill: "#FBBF24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68,90 L 69,92 L 72,93 L 69,94 L 68,97 L 67,94 L 64,93 L 67,92 Z",
    fill: "#34D399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParesPremium);
export default __webpack_public_path__ + "static/media/pares_premium.3d7788a2bb0fac28a6c2c85b256e479b.svg";
export { ForwardRef as ReactComponent };